import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import DualBrand from "@/components/site/DualBrand";
import Manifesto from "@/components/site/Manifesto";
import B2BLeadCapture from "@/components/site/B2BLeadCapture";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location.hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <DualBrand />
      <Manifesto />
      <B2BLeadCapture />
    </main>
  );
}
